const REPORT_STATUS_LABEL = {
  approved: "goedgekeurd",
  submitted: "ingediend",
  draft: "concept",
};

function proposalFor(report, sectionType) {
  return (report?.day_start_proposals || []).find((proposal) =>
    proposal?.section_type === sectionType
  ) || null;
}

function formatDutchDate(value) {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[3]}-${match[2]}-${match[1]}` : String(value || "");
}

function historicalSourceLabel(proposal) {
  if (!proposal?.source_report_date) return null;
  const status = REPORT_STATUS_LABEL[proposal.source_report_status] ||
    proposal.source_report_status || "onbekend";
  return `${formatDutchDate(proposal.source_report_date)} (${status})`;
}

export function dayStartProposalSourceLabel(proposal) {
  if (!proposal) return "Nog geen voorstel voorbereid";

  const explicitPreplan = proposal.proposal_origin === "explicit_preplan" ||
    proposal.selection_reason === "current_date_preplan";
  const historical = historicalSourceLabel(proposal);

  if (explicitPreplan) {
    if (proposal.preplan_mode === "replace") {
      return "Voorplanning (complete ploeg)";
    }
    if (proposal.preplan_mode === "patch") {
      return historical
        ? `Voorplanning (wijzigingen) + basis ${historical}`
        : "Voorplanning (wijzigingen)";
    }
    return historical ? `Voorplanning + basis ${historical}` : "Voorplanning";
  }

  if (historical) return historical;
  if (proposal.selection_reason === "report_is_read_only") return "Niet van toepassing";
  return "Geen bruikbare historische bron";
}

export function staffingDisplayState(report) {
  const actualRows = Array.isArray(report?.team_members) ? report.team_members : [];
  const proposal = proposalFor(report, "staffing");
  const proposedRows = Array.isArray(proposal?.snapshot) ? proposal.snapshot : [];
  const confirmed = Boolean(report?.staffing_confirmed_at);

  if (confirmed || actualRows.length > 0) {
    return {
      rows: actualRows,
      proposal: null,
      isProposal: false,
      note: confirmed ? "Bevestigde bezetting" : "Huidige rapportinvoer, nog niet bevestigd",
    };
  }

  if (proposedRows.length > 0) {
    const explicitPreplan = proposal?.proposal_origin === "explicit_preplan" ||
      proposal?.selection_reason === "current_date_preplan";
    const note = explicitPreplan
      ? proposal?.preplan_mode === "replace"
        ? "Voorgeplande complete ploeg. Nog niet bevestigd als feitelijke bezetting."
        : "Voorplanning met wijzigingen op de actuele ploegbasis. Nog niet bevestigd als feitelijke bezetting."
      : "Voorstel op basis van een eerdere werkdag. Nog niet bevestigd als feitelijke bezetting.";
    return {
      rows: proposedRows,
      proposal,
      isProposal: true,
      note,
    };
  }

  return {
    rows: [],
    proposal,
    isProposal: false,
    note: "Nog geen personeelsbezetting voorbereid",
  };
}

export function formatReportClock(value) {
  const match = String(value || "").match(/^(\d{2}):(\d{2})(?::\d{2})?/);
  return match ? `${match[1]}:${match[2]}` : "-";
}
